export const INBOX_TABS = ["needs_reply", "waiting_on_respondent", "resolved", "closed"] as const;
export type InboxTab = (typeof INBOX_TABS)[number];
